import type { JSX } from 'react';
import { TextField } from '../../../../_components/TextField.js';
import type { Palette } from '../../../../_theme/palette.js';
import type { SurveyQuestion } from '../../types.js';

interface ShortTextFieldProps {
  palette: Palette;
  question: SurveyQuestion;
  value: unknown;
  onChange: (value: unknown) => void;
  inputType?: 'text' | 'email' | 'number' | 'date' | 'datetime-local' | 'time' | 'month' | 'tel' | 'url';
}

export function ShortTextField({ palette, question, value, onChange, inputType = 'text' }: ShortTextFieldProps): JSX.Element {
  return (
    <TextField
      palette={palette}
      value={typeof value === 'string' || typeof value === 'number' ? String(value) : ''}
      onChange={onChange}
      type={inputType}
      placeholder={question.settings?.placeholder ?? ''}
      minLength={question.settings?.minLength}
      maxLength={question.settings?.maxLength}
      min={inputType === 'number' ? question.settings?.min : undefined}
      max={inputType === 'number' ? question.settings?.max : undefined}
      step={inputType === 'number' ? question.settings?.step : undefined}
      ariaLabel={question.label}
    />
  );
}
